import api from '@/modules/api'
import { AxiosResponse } from 'axios'
import PlanRsp from '@/services/models/PlanRsp'
import {IApiResponse} from '@/common/models/interface'


export default class PlanService{

  /**
   * Create an order
   *
   * @returns {Promise<any>}
   * @memberof PlanService
   */
  public async getAll(): Promise<IApiResponse<PlanRsp[]>> {
    const res: AxiosResponse = await api.get('Plan/List')
    return res.data
  }

  /**
   * Create an order
   *
   * @returns {Promise<any>}
   * @memberof PlanService
   */
  public async getPlan(id: string): Promise<IApiResponse<PlanRsp>> {
    const res: AxiosResponse = await api.get(`Plan/${id}`)
    return res.data
  }
}
